export default {
  'API Reference': 'code',
  Business: 'business',
  Checkmark: 'checkmark',
  Feedback: 'feedback',
  GitLab: 'gitlab',
  Guidelines: 'document',
  Info: 'info',
  Message: 'message',
  Note: 'note',
  Payment: 'payment',
  Payout: 'payout',
  'QR Code': 'QR',
  Refund: 'refund',
  Warning: 'warning',
};
